/* eslint-disable max-len */
/* eslint-disable security/detect-object-injection */
/* eslint-disable react/no-unescaped-entities */
import React, { Suspense, lazy,useContext,useEffect,useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { Route, Routes, useLocation, useNavigate,
} from 'react-router-dom';
import AnimatedPage from '../components/Animation/AnimatedPage';
import Layout from '../components/Layout';
import Login from '../pages/auth/Login';
import ResetPassword from '../pages/auth/ResetPassword';
import GlobalContext from '../components/Context/GloablContext';
import { ComponentsBasedOnRole } from './_nav';
import { useCallback } from 'react';
import { handleClockIn, hanldeBranch, logout, setUserType, verifyOtp } from '../pages/auth/authSlice';
import { CognitoCurrentData, CognitoData } from '../CommonMethods/CognitoData';
import EmptyScreen from '../components/EmptyScreen';
import PasswordReset from '../pages/auth/PasswordReset';
import { FetchBranch } from '../CommonMethods/FetchBranch';
import { handleGroup } from '../redux/commonSlice';
import { removeAssociationSelection, setLoading } from '../pages/ManageAssociation/AssociationSlice';
import { dataService } from '../services/data.services';
import { resetState } from '../pages/StudentMaster/Attendance/ModifyAttendance/StudentAttendanceSlice';
import MobileScreenResetPassword from '../components/MobileResetPasswordScreen';
const CustomOverLay = lazy(() => import('../components/CustomOverlay'));
import BalanceSheet from '../pages/FinancialStatements/BalanceSheet';
import ProfitAndLoss from '../pages/FinancialStatements/ProfitAndLoss';
import TrialBalance from '../pages/FinancialStatements/TrialBalance';
import ReceiptsAndPayments from '../pages/FinancialStatements/ReceiptsAndPayments';
import AccessDenied from '../components/AccesDenied';

export default function NavigationRoutes(props) {
    const dispactch=useDispatch()
    const [loading, setloading] = useState(true)
    const {UpdateCall, rolesGlobal}=useContext(GlobalContext)
    const auth = useSelector(state => state.auth);
    const GlobalChange=useSelector(state=>state.GlobalData)
    const location = useLocation();
    const [CurrentUser, setCurrentUser] = useState('');
    const [allRoles, setAllRoles] = useState([])
    const { loggedIn } = auth;
    const navigate = useNavigate()

    /**
     * The FetchBranchDetails function fetches branch details from an API and dispatches a clock-in
     * action if the response status is 200.
     */
    const FetchBranchDetails=async (id)=>{
        // handleClockIn
        try {
            let res = await dataService.GetAPI(`branch/${id}`, true);
            if(res.data.status===200){
                dispactch(handleClockIn(res.data.data?.clock_in_out_facitilty))
            }
        } catch (error) {
            console.log(error)
        }
    }
    
    /* The above code is a JavaScript React function called `fetchUserAttributes`. It is an
    asynchronous function that is used to fetch user attributes from a Cognito service. */
    const fetchUserAttributes= useCallback(
        async() => {
            try {
                // if(!auth.loggedIn && (location.pathname!=='/reset-password' || location.pathname!=='/reset-new-password')){
                //     navigate('/')

                // }
                setloading(true)
                dispactch(removeAssociationSelection())
                const user = await CognitoCurrentData();
                const user1 = await CognitoData()   
                const roles = rolesGlobal?.length > 0 ? rolesGlobal : user1?.idToken?.payload['cognito:groups']
                const userType = user['custom:user_type']; // Get the user type attribute
                if(userType==='branch-user' || userType==='staff-user'){ //Only thse two user can have clock in clock out facility. --> Checking usertype and calling the method
                    FetchBranchDetails(user['custom:branch_id'])

                }
                dispactch(handleGroup(roles ||[]))
                setAllRoles(roles || ['balance-sheet', 'profit-and-loss-sheet','trial-balance-sheet','receipts-and-payments'])
                let  branchArr=auth.branches || [];
                if(auth.branches?.length===0){
                    branchArr= await FetchBranch(user);
                }
                if((branchArr)?.length>0){
                    const localbranch=JSON.parse(localStorage.getItem('branch_details'))

                    if(Object.keys(localbranch)?.length===0 && branchArr?.length===1){
                        localStorage.setItem('branch_details',JSON.stringify({name:branchArr[0].name,id:branchArr[0].id}));
                        
                    }
                    
                    const arr=branchArr
                    dispactch(hanldeBranch(arr))
                    setCurrentUser(userType)
                    const myObj={
                        userType:userType,
                        branches:arr
                    }
                    dispactch(setUserType(myObj));
                    let branchStatus=localStorage.getItem('branch-reload')
                    if(userType==='branch-user' &&   (branchStatus===undefined) ){
                        localStorage.setItem('branch-reload',1)
                        navigate('profile/branch-profile')
                    }
                    
                }else{
                    setCurrentUser('no-branch')
                    dispactch(setUserType('no-branch'));
                }
                // location(window.location.pathname)
            } catch (error) {
                // Handle error fetching user attributes
                setloading(false)
                if(loggedIn){
                    const logoutChannel = new BroadcastChannel('logout-channel');
                    logoutChannel.postMessage({ type: 'sessionExpire' });
                }
            } finally{
                setLoading(false)
            }
        },
        [CurrentUser,UpdateCall,GlobalChange,logout],
    )
    
    
    /* The `useEffect` hook is used to perform side effects in a React component. In this case, the
    effect is triggered when the component mounts or when the dependencies (`fetchUserAttributes`,
    `logout`, `GlobalChange`) change. */
    useEffect(() => {
        if(CurrentUser==='' || CurrentUser===undefined|| CurrentUser==='no-branch'){
            setLoading(true)
            fetchUserAttributes();
        }
        setloading(false)
    }, [fetchUserAttributes,logout,GlobalChange, loggedIn]);

    /* The `useEffect` hook is used to perform side effects in a React component. In this case, the
    effect is triggered when the `location.pathname` changes. */
    useEffect(()=>{
        if(!(
            location.pathname.includes("/student-master/student-attendance/view-attendance")||
            (location.pathname.includes("/student-master/student-attendance"))||
            (location.pathname==='/student-master/student-attendance/modify-attendance')||
            location.pathname.includes("/employee-master/employee-attendance/view-attendance")||
            (location.pathname.includes("/employee-master/employee-attendance"))||
            (location.pathname==='/employee-master/employee-attendance/modify-attendance'))
        ){
            dispactch(resetState())  
        }
    },[dispactch,location.pathname])

    /* The `useEffect` hook is used to perform side effects in a React component. In this case, the
    effect is triggered when the `loggedIn` variable changes. If the user is not logged in
    (`loggedIn` is false), the `setCurrentUser('')` function is called to set the `CurrentUser`
    state to an empty string. */
    useEffect(()=>{
        if(!loggedIn){
            setCurrentUser('')
            if(location.pathname !== '/reset-password' && location.pathname !== "/reset-new-password"){
                navigate('/')
            }
        }
    },[loggedIn])

    useEffect(() => {
        const updateChannel = new BroadcastChannel('update-channel');
        updateChannel.onmessage = (event) => {
            if (event.data.type === 'updated') {
                dispactch(handleGroup(event.data.Roles ||[]))
                setAllRoles(event.data.Roles || ['balance-sheet', 'profit-and-loss-sheet','trial-balance-sheet','receipts-and-payments'])
            }
        };
        return () => {
            updateChannel.close()
        };
    }, []);

    return (

        <Suspense fallback={<div></div>}>{!loading &&
        <>
            <Routes location={location}>
                {!loggedIn ? (
                    <>
                        <Route
                            exact
                            path="*"
                            element={
                                <CustomOverLay Active text='Loading School Management Application...'classKey={`flex flex-col justify-center items-center sidebarOpenedOverlay`}/>
                            }
                        />
                        <Route path="/" element={
                            <AnimatedPage>
                                <Login />
                            </AnimatedPage>} />
                        <Route path="/reset-password" element={
                            <AnimatedPage><ResetPassword /></AnimatedPage>} />
                        <Route path="/reset-new-password" element={
                            <AnimatedPage><PasswordReset /></AnimatedPage>} />
                        <Route path="/404" element={
                            <>
                                <EmptyScreen type={'not-logged'} tittle={"404"} />
                            </>} />   
                    </>
                ) : (
                        
                    ComponentsBasedOnRole[CurrentUser] && 
                    <Route element={<Layout {...props} />} key={location.key}>
                        {ComponentsBasedOnRole[CurrentUser] &&
                        ComponentsBasedOnRole[CurrentUser].map((nav) => (
                            <Route
                                key={nav.path}
                                path={nav.path}
                                element={
                                    (CurrentUser === 'institution-admin' ||
                                        CurrentUser === 'no-branch' ||
                                        (CurrentUser === 'institution-user' || CurrentUser === 'branch-user' || CurrentUser === 'staff-user') &&
                                        allRoles?.includes(nav.roleKey)) || nav?.roleKey === 'profile' ? (
                                            React.cloneElement(nav.element, props)
                                        ) : (
                                            (() => {
                                                return <AccessDenied />;
                                            })()                                        )
                                }
                            />
                        ))}

                        <Route path="*" element={
                            allRoles?.includes("balance-sheet") && location.pathname.includes('/financial-statements/balance-sheet') ? <BalanceSheet type="main" />
                                : allRoles?.includes("profit-and-loss-sheet") && location.pathname.includes('/financial-statements/profit-and-loss-sheet') ? <ProfitAndLoss type="main" />
                                    : allRoles?.includes("trial-balance-sheet") && location.pathname.includes('/financial-statements/trial-balance-sheet') ? <TrialBalance type="main" />
                                        : allRoles?.includes("receipts-and-payments") && location.pathname.includes('/financial-statements/receipts-and-payments') ? <ReceiptsAndPayments type="main" />
                                            : <EmptyScreen tittle="404" />
                        } />   
                        <Route path="/404" element={
                            <>
                                <EmptyScreen tittle={"404"} />
                            </>
                        } />   
                        <Route path="/mobile-reset-password" element={
                            <>
                                <MobileScreenResetPassword />
                            </>
                        } />                     

                    </Route>
                )}
                <Route
                    path="*"
                    element={
                        <CustomOverLay Active text='Loading School Management Application...'classKey={`flex flex-col justify-center items-center sidebarOpenedOverlay`}/>
                    }
                />
            </Routes>
        </>
        }</Suspense>


    );
}
